import PropTypes from 'prop-types';

const RetryIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill={fill} fillRule="evenodd">
        <g fill={fill}>
          <path d="M24,0 C37.254834,0 48,10.745166 48,24 C48,37.254834 37.254834,48 24,48 C10.745166,48 0,37.254834 0,24 C0,10.745166 10.745166,0 24,0 Z M23.5666667,9.14812013 L23.5666667,12.4310474 C16.5666667,12.9045465 11,18.4287029 11,25.2155237 C11,28.6247174 12.4,31.8445114 14.9666667,34.2751402 C17.5,36.6742025 20.9,38 24.5,38 C31.9666667,38 38,32.2548773 38,25.2155237 C38,23.8265929 37.8,22.5007954 37.3333333,21.2065645 C36.9333333,20.0386 35.6,19.4072678 34.3666667,19.7860671 C33.1333333,20.1648664 32.4666667,21.4275307 32.8666667,22.5954952 C33.1666667,23.416227 33.3,24.3000921 33.3,25.1839571 C33.3,29.7611153 29.3666667,33.5175416 24.5,33.5175416 C22.1333333,33.5175416 19.9333333,32.6652432 18.2666667,31.0869128 C16.6,29.5085824 15.7,27.4251863 15.7,25.1839571 C15.7,20.8908984 19.1666667,17.3554383 23.5666667,16.9135057 L23.5666667,20.1332998 C23.5666667,21.080298 24.7,21.6169304 25.5,21.0487314 L33.1,15.5561416 C33.7333333,15.1142091 33.7333333,14.1987774 33.1,13.7568449 L25.5,8.23268849 C24.7,7.66448955 23.5666667,8.20112189 23.5666667,9.14812013 Z" />
        </g>
      </g>
    </svg>
  </div>
);

RetryIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

RetryIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default RetryIcon;
